import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ConfirmDeleteDialog from './ConfirmDeleteDialog'
import moment from 'moment';
import { MuiGrid, MuiTypography, MuiEdit, MuiNotificationsActiveIcon, MuiClickAwayListener, MuiPopper, MuiClear, MuiMenuItem, MuiMenu, MuiAvatar, MuiDivider, MuiCard, MuiCardActions, MuiKeyboardArrowDown, MuiSettingsIcon, MuiDelete } from '../../ui/MaterialUIComponents';
import { Link } from 'react-router-dom';
import routes from "../../navigation/Routes"
import DialogComponent from '../school/teacher/DialogComponent'
import { toast } from 'react-toastify';
import lodash from 'lodash'
import * as StringReplacer from '../../../i18n/StringReplacer'
import spinner from "../../ui/icons/spinner.gif"
import theme from '../../../assests/theme'
import { TextUtil } from '../../../utils'
import { saveSchoolConcurrently } from '../../../utils/ConcurrentSchoolSaveUtil';

const useStyles = makeStyles(theme => ({
  // root: {
  //   display: 'flex',
  // },
  mainGrid: {
    padding: 20, position: 'sticky', backgroundColor: theme.palette.grey.lightest
  },
  drawer: {
    //width: drawerWidth,
    //flexShrink: 0,
  },
  drawerPaper: {
    //width: drawerWidth,
    background: '#D2EAFE'
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  square: {

    [theme.breakpoints.down('xl')]: {
      width: theme.spacing(14),
      height: theme.spacing(14),
    },
    [theme.breakpoints.down('lg')]: {
      width: theme.spacing(14),
      height: theme.spacing(14),
    },
    [theme.breakpoints.down('md')]: {
      width: theme.spacing(12),
      height: theme.spacing(12),
    },
    [theme.breakpoints.down('sm')]: {
      width: theme.spacing(10),
      height: theme.spacing(10),
    },
    background: 'white'
  },
  large: {
    width: theme.spacing(10),
    height: theme.spacing(10),

    [theme.breakpoints.down('xl')]: {
      width: theme.spacing(10),
      height: theme.spacing(10),
    },
    [theme.breakpoints.down('lg')]: {
      width: theme.spacing(9),
      height: theme.spacing(9),
    },
    [theme.breakpoints.down('md')]: {
      width: theme.spacing(8),
      height: theme.spacing(8),
    },
    [theme.breakpoints.down('sm')]: {
      width: theme.spacing(7),
      height: theme.spacing(7),
    },
    [theme.breakpoints.down('xs')]: {
      width: theme.spacing(6),
      height: theme.spacing(6),
    },
    color: theme.palette.primary.dark,
    background: theme.palette.primary.lighter,
    fontWeight: 600
  },
  paper: {

    width: '100%',
  },
  toolbar: theme.mixins.toolbar,
  styleForSquareGrid: {
    padding: 5
  },
  styleForSquareNumberTextStyle: { 

    [theme.breakpoints.down('md')]: {
      fontSize: '30px'
    },
    fontSize: '40px' 
  },
  styleForSquareTextStyle: {
    [theme.breakpoints.down('md')]: {
      fontSize: '14px'
    },


    fontSize: '18px' },
  schoolNameStyle: {
    font: "Arial", fontSize: '28px', wordWrap: 'break-word'
  },
  schoolCityStyle: { font: "Arial", fontSize: '18px' },
  paddingStyle: { paddingTop: '5px' },
  updatedOnGreyStyle: { color: "#000000", opacity: '0.6', paddingRight: 4 },
  updatedOnTextStyle: { paddingRight: 4 },
  paddingStyleForIconGrid: { paddingTop: 5 },
  paddingStyleForEditIcon: { paddingTop: 10, paddingRight: 10, paddingBottom: 10 },
  styleForIconTextStyle: { fontSize: '13px' },
  styleForNotificationIconTextStyle: { fontSize: '13px', color: theme.palette.orange },
  paddingStyleForIcon: { padding: 10 }

}));

export default function DashboardDrawer(props) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const [openDeleteDialog, setOpenDialog] = React.useState(false);
  const [openConfirmDialogForPendingActions, setOpenConfirmationDialogForPendingActions] = React.useState(false);
  // const [acceptOwnerFlag, setAcceptOwnerFlag] = 
  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen);
  };

  const handleClose = event => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  }

  const onClickOfDelete = async () => {
    let school = props.activeSchool;
    school.isArchived = true;

    let result = await saveSchoolConcurrently(props.editSchoolInformation,
      props.userInformation._id,
      school._id,
      school, "School Deleted Successfully");
    
    if (result.success) {

      window.location.reload(true);
    } else {
      school.isArchived = false;
      setOpenDialog(prevOpen => !prevOpen);
    }

  }

  const openDeleteDialogMethod = event => {
    setOpenDialog(prevOpen => !prevOpen);

  };



  const deleteDialog = () => {
    const { classes } = props
    return (
      <MuiGrid container xs={12}>
        <ConfirmDeleteDialog {...props} name={props.activeSchool.name} onClickDelete={onClickOfDelete} cancel={cancel} open={openDeleteDialog} />
      </MuiGrid>
    )
  }
  const cancel = () => {
    setOpenDialog(prevOpen => !prevOpen);
  }
  const onClickOfPendingActions = () => {
    setOpenConfirmationDialogForPendingActions(true);
  }
  const renderSummaryCube = (number, textValue) => {

    return (<MuiGrid className={classes.styleForSquareGrid}>
      <MuiAvatar variant='square' className={classes.square}>

        <MuiGrid container direction='row' justify='center' alignItems='center' xs={12} >
          <MuiGrid item xs={12}> <MuiTypography className={classes.styleForSquareNumberTextStyle} >
            {number}
          </MuiTypography></MuiGrid>
          <MuiGrid item xs={12}>
            <MuiTypography className={classes.styleForSquareTextStyle}  >
              {textValue}
            </MuiTypography>
          </MuiGrid></MuiGrid>
      </MuiAvatar>
    </MuiGrid>

    )
  }
  const isPendingActionsAvailable = () => {
    for (let i = 0; i < props.userInformation.profiles.length; i++) {
      // let index = props.userInformation.profiles[i].schools.indexOf(props.activeSchool._id)
      let index = lodash.findIndex(props.userInformation.profiles[i].schools, ['_id', props.activeSchool._id])
      if (index != -1) {
        if ((props.userInformation.profiles[i].profileType == "ADMIN" && props.activeSchool.transferOwnerId == null) || (props.userInformation.profiles[i].profileType == "OWNER" && props.activeSchool.transferOwnerId == null
          || (props.userInformation.profiles[i].profileType == "OWNER" && props.activeSchool.transferOwnerId !== null))) {
          return false;
        }
      }
    }
    return true;
  }

  const handleReject = async () => {
    const i18n = props.i18n
    let schoolData = { ...props.activeSchool };
    let transferOwnerId = schoolData.transferOwnerId
    schoolData.transferOwnerId = null;
    let response = await props.editSchoolInformation(props.activeSchool.ownerId, props.activeSchool._id, schoolData);
    if (response != null) {
      response.createdBy = schoolData.createdBy;
      response.modifiedBy = schoolData.modifiedBy;
      props.history.push("/")
      let res = await props.reuestRejectedEmail(props.activeSchool.email, transferOwnerId, props.activeSchool._id);
      if (res.message != null) {
        toast(i18n.toastMsgs.ownerInviteReject);

      }
    }
    await props.setActiveSchool(response);
    setOpenConfirmationDialogForPendingActions(false);
  }

  const handleAccept = async () => {
    const i18n = props.i18n
    if (props.activeProfileType !== undefined && props.activeProfileType !== "ADMIN") {
      return <MuiGrid container xs={12} alignItems="stretch" justify='center' alignContent='center' direction='column' >
        <img src={spinner} alt="none" style={theme.spinnerImgStyle} /></MuiGrid>
    }
    let schoolData = { ...props.activeSchool };
    let response = await props.makeOwner(props.activeSchool.transferOwnerId);
    if (response != null) {
      response.createdBy = schoolData.createdBy;
      response.modifiedBy = schoolData.modifiedBy;
      props.history.push("/");
      toast(i18n.toastMsgs.ownerInviteAccept);
    }

    await props.getUserProfileByCognitoId(props.userInformation.cognitoId);
    await props.setActiveSchool(response);
    setOpenConfirmationDialogForPendingActions(false);
  }

  const { i18n } = props

  const handleCloseDialog = () => {
    setOpenConfirmationDialogForPendingActions(false)
  }
  return (

    <React.Fragment>

      <MuiGrid container xs direction='row' className={classes.mainGrid}>
        {openDeleteDialog ? deleteDialog() : null}
        <MuiGrid container xs={12} justify='space-around' direction='row'>
          <MuiGrid container xs >
            <MuiGrid >
              <MuiGrid item style={{ paddingRight: 15 }}>
                <MuiAvatar className={classes.large}>{props.activeSchool.name.charAt(0)}</MuiAvatar>
              </MuiGrid>
            </MuiGrid>
            <MuiGrid xs >
              <MuiGrid item xs={12} >
                <MuiTypography className={classes.schoolNameStyle} align='left'>
                  {props.activeSchool.name}
                </MuiTypography>
                <MuiTypography className={classes.schoolCityStyle} align='left' >
                  {props.activeSchool.address.city}
                </MuiTypography>
              </MuiGrid>
              <MuiGrid container direction='row' xs={12} justify='flex-start' className={classes.paddingStyle} >
                <MuiGrid item >
                  <MuiTypography align='left' variant="body" className={classes.updatedOnGreyStyle} gutterBottom >
                    {"  " + i18n.commonTexts.updatedOn}

                  </MuiTypography>
                </MuiGrid>
                <MuiGrid item >
                  <MuiTypography align='left' variant="body" gutterBottom className={classes.updatedOnTextStyle} >
                    <span>{moment(props.activeSchool.modifiedDate).format('DD-MMM-YYYY hh:mm A')}</span>
                  </MuiTypography>
                </MuiGrid>
                <MuiGrid item >
                  <MuiTypography align='left' variant="body" className={classes.updatedOnGreyStyle} gutterBottom >
                    {"  " + i18n.commonTexts.by}

                  </MuiTypography>
                </MuiGrid>
                <MuiGrid item >
                  <MuiTypography variant="body" gutterBottom>

                    {TextUtil.capitalize(props.activeSchool.modifiedBy.firstName) + " " + TextUtil.capitalize(props.activeSchool.modifiedBy.lastName)}
                  </MuiTypography>
                </MuiGrid>
              </MuiGrid>
              <MuiGrid container direction='row' xs={12} justify='flex-start' className={classes.paddingStyle} >
                <MuiGrid container direction='row' xs={12} className={classes.styleForIconTextStyle}>
                  <MuiGrid item className={classes.paddingStyleForEditIcon}>
                    <Link style={{ textDecoration: 'none' }} to={{
                      pathname: routes.editSchool,
                      state: {
                       // activeSchool: props.activeSchool

                      }
                    }}>

                      <MuiGrid container direction='column' justify='center' alignItems='center' >
                        <MuiGrid item  >
                          <MuiEdit color='primary' />
                        </MuiGrid>
                        <MuiGrid item  >
                          <MuiTypography align='center' className={classes.styleForIconTextStyle} color='primary'>
                            {i18n.commonTexts.edit}
                          </MuiTypography>
                        </MuiGrid>
                      </MuiGrid>
                    </Link>
                  </MuiGrid>
                  {isPendingActionsAvailable() &&
                    <MuiGrid item className={classes.paddingStyleForIcon}>
                      <MuiGrid container direction='column' justify='center' alignItems='center'
                        onClick={onClickOfPendingActions} style={{
                          cursor: 'pointer'
                        }}
                      >
                        <MuiGrid item  >
                        <MuiNotificationsActiveIcon style={{ color: theme.palette.orange }}  />
                        </MuiGrid>
                        <MuiGrid item  >
                          <MuiTypography align='center' className={classes.styleForNotificationIconTextStyle} >
                          {i18n.dashBoard.notifications}
                    </MuiTypography>
                        </MuiGrid>
                      </MuiGrid>
                      <MuiGrid item >
                        {openConfirmDialogForPendingActions &&
                          <DialogComponent
                            openDialog={openConfirmDialogForPendingActions}
                            handleCloseDialog={onClickOfPendingActions}
                            title={i18n.createadmin.titleForOwnershipDialog}
                            text={props.activeSchool.name !== undefined && StringReplacer.getFormatedMessage(i18n.createadmin.textForOwnerShipDialog, { School_name: props.activeSchool.name })}
                            actionNameForNo={"Decline"}
                            actionNameForYes={"Accept"}
                            handleClickOnYes={handleAccept}
                            handleCloseDialog={handleCloseDialog}
                            handleReject={handleReject}
                          />
                        }
                      </MuiGrid>
                    </MuiGrid>

                  }
                  {props.activeProfileType == "OWNER" && <MuiGrid item className={classes.paddingStyleForIcon}>
                    <Link style={{ textDecoration: 'none' }} to={{
                      pathname: routes.createAdmin
                    }}>
                      <MuiGrid container direction='column' justify='center' alignItems='center' >
                        <MuiGrid item  >
                          <MuiSettingsIcon color='primary'/>
                        </MuiGrid>
                        <MuiGrid item  >
                          <MuiTypography align='center' className={classes.styleForIconTextStyle} color='primary'>
                            {i18n.dashBoard.manageAdmin}
                      </MuiTypography>
                        </MuiGrid>
                      </MuiGrid>
                    </Link>
                  </MuiGrid>}

                  {/* {props.activeProfileType == "OWNER" &&

                    < MuiGrid item className={classes.paddingStyleForIcon}>
                      <MuiGrid container direction='column' justify='center' alignItems='center'
                        onClick={openDeleteDialogMethod} style={{
                          cursor: 'pointer'
                        }}
                      >
                        <MuiGrid item  >
                          <MuiDelete color='primary' />
                        </MuiGrid>
                        <MuiGrid item  >
                          <MuiTypography align='center' className={classes.styleForIconTextStyle} color='primary'>
                            {i18n.commonTexts.delete}
                          </MuiTypography>
                        </MuiGrid>
                      </MuiGrid>

                    </MuiGrid>} */}
                </MuiGrid>
              </MuiGrid>
            </MuiGrid>
          </MuiGrid>
          <MuiGrid container xs={6} sm={6} lg={7}  md={6} justify='flex-end'>

            {renderSummaryCube(props.activeSchool.school_master.totalNumberOfGrades, i18n.dashBoard.grades)}
            {renderSummaryCube(props.activeSchool.school_master.totalNumberOfGroups, i18n.dashBoard.groups)}
            {renderSummaryCube(props.activeSchool.school_master.subjects.length, i18n.dashBoard.subjects)}
            {renderSummaryCube(props.activeSchool.school_master.electives.length, i18n.dashBoard.electives)}
            {renderSummaryCube(props.activeSchool.school_master.teachers.length, i18n.dashBoard.teachers)}
            {renderSummaryCube(props.activeSchool.school_master.sharedRooms.length, i18n.dashBoard.rooms)}

          </MuiGrid>

          <MuiGrid >



          </MuiGrid></MuiGrid></MuiGrid>
    </React.Fragment >

  );
}
